export const counter = { value: 0 };
